import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
import CheckBox from "~/componentes/CustomForm/Check/styles/CheckBox";

import { Container } from './styles';
import AtividadesList from "./AtividadesList";
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import Acoordion from '~/componentes/Acoordion';
import Button from '~/componentes/Button';
import IconLixeira from '~/assets/icones/IconLixeira.svg';

function CreateContent({ mountedData }) {
  const [clientes, setClientes] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [horaTotal, setHoraTotal] = useState(mountedData ? mountedData?.horaTotal : 0);
  const [horarios, setHorarios] = useState([]);
  const [atividades, setAtividades] = useState([]);
  const [ordemServicoAtividades, setOrdemServicoAtividades] = useState([]);
  const [cliente, setCliente] = useState({});
  const [projeto, setProjeto] = useState({});
  const [dataOS, setDataOS] = useState(new Date().toISOString().split('T')[0]);
  const [ativo, setAtivo] = useState("true");

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/ordemservico/clientes", { params: { ativo: 1, dataEmissao: dataOS } })
      .then(response => setClientes(response.data));
    api.get("/signed/empresa/gestorprojeto/ordemservico/projetos", { params: { ativo: 1, idCliente: cliente?.id ? cliente?.id : 0, dataEmissao: dataOS } })
      .then(response => setProjetos(response.data));

    let listaHora = [{
      id: 1,
      titulo: "º Horário",
      idProjetoAtividade: 0,
      horaInicial: "00:00",
      horaFinal: "08:00",
    }];
    setHorarios(listaHora);
    setOrdemServicoAtividades([]);

  }, [cliente, projeto, dataOS]);

  useEffect(() => {
    let lista = [];
    if (projeto?.atividades) {
      for (let item of projeto?.atividades) {
        lista.push({ check: false, ...item });
      }
    }
    setAtividades(lista);
  }, [projeto]);

  useEffect(() => {
    let lista = [];
    if (projeto?.atividades) {
      for (let item of projeto?.atividades) {
        const indexFind = ordemServicoAtividades?.findIndex(e => e?.id == item?.id);

        lista.push({ check: (indexFind > -1 ? true : false), ...item });
      }
    }
    setAtividades(lista);

    if (ordemServicoAtividades?.length > 0) {
      let listaHor = [];
      for (const itemAtivo of horarios) {
        listaHor.push({ ...itemAtivo, idProjetoAtividade: ordemServicoAtividades[0]?.id });
      }
      setHorarios(listaHor);
    }

  }, [ordemServicoAtividades]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          horarios,
          atividades,
          ativo: ativo === "true" ? true : false,
        };

        let response = await api.post("/signed/empresa/gestorprojeto/ordemservicomod2", thisData);
        if (response?.status === 200) {
          closeReload && closeReload();
        }

        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao cadastrar essa Ordem de Serviço, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja cadastrar essa Ordem de Serviço?`,
        successModal: `Ordem de Serviço cadastrada com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são
            campos obrigatórios
          </p>
        </div>
        <div className="row">
          <div className="col s12 m12 l12">
            <AtividadesList setter={setAtividades} defaultData={mountedData?.atividades || []} />
          </div>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateContent;
